import { ApiErrorResponse } from '@/interfaces/api/general/errorResponses';
import { generalApi } from '@/lib/api/general';
import { defineMessages } from '@/lib/i18n';
import { dispatchCheckApiError, MainContext } from '@/store/main/actionsMain';
import { commitAddNotification } from '@/store/main/mutations';
import { AxiosError } from 'axios';
import { SdsesFilterParams } from '@/composables/useSdsFilter';

const m = defineMessages({
  searchCriteriaCreated: 'マイフィルターを作成しました',
  searchCriteriaUpdated: 'マイフィルターを更新しました',
  searchCriteriaDeleted: 'マイフィルターを削除しました',
});

export const actionGetUserSearchCriteria = async (
  context: MainContext,
  payload: {
    userId: string;
    companyId: string;
  }
) => {
  try {
    return await generalApi.getUserSearchCriteria(
      payload.companyId,
      payload.userId
    );
  } catch (error) {
    const axiosError = error as AxiosError<ApiErrorResponse>;
    await dispatchCheckApiError(context, axiosError);
  }
};

export const actionCreateUserSearchCriteria = async (
  context: MainContext,
  payload: {
    userId: string;
    companyId: string;
    name: string;
    criteria: SdsesFilterParams;
  }
) => {
  try {
    const response = await generalApi.postUserSearchCriteria(payload);
    commitAddNotification(context, {
      messageKey: m.searchCriteriaCreated,
      color: 'success',
    });
    return response;
  } catch (error) {
    const axiosError = error as AxiosError<ApiErrorResponse>;
    await dispatchCheckApiError(context, axiosError);
  }
};

export const actionUpdateUserSearchCriteria = async (
  context: MainContext,
  payload: {
    userId: string;
    companyId: string;
    searchCriteriaId: string;
    name: string;
  }
) => {
  try {
    const response = await generalApi.putUserSearchCriteria(payload);
    commitAddNotification(context, {
      messageKey: m.searchCriteriaUpdated,
      color: 'success',
    });
    return response;
  } catch (error) {
    const axiosError = error as AxiosError<ApiErrorResponse>;
    await dispatchCheckApiError(context, axiosError);
  }
};

export const actionDeleteUserSearchCriteria = async (
  context: MainContext,
  payload: {
    userId: string;
    companyId: string;
    searchCriteriaId: string;
  }
) => {
  try {
    const response = await generalApi.deleteUserSearchCriteria(payload);
    commitAddNotification(context, {
      messageKey: m.searchCriteriaDeleted,
      color: 'success',
    });
    return response;
  } catch (error) {
    const axiosError = error as AxiosError<ApiErrorResponse>;
    await dispatchCheckApiError(context, axiosError);
  }
};
